export const API_BASE_END_POINT =
	process.env.REACT_APP_PUBLIC_API_URL || 'http://localhost:8080'
